module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    class: _vm.state,
    on: {
      "click": _vm.switchState
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-767907f5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/content/content.vue
// module id = 269
// module chunks = 25